import React, { Suspense } from 'react';
import { useRouter } from 'next/router';
import ScreenCbtBest from 'src/app.feature/academy/cbt.best/screen/ScreenCbtBest';
import ScreenCbtList from 'src/app.feature/academy/cbt.list/screen/ScreenCbtList';
import ScreenCbtCategory from 'src/app.feature/academy/cbt.category/screen/ScreenCbtCategory';

const ScreenCbtHome = () => {
  const router = useRouter();
  const { examTypeIds } = router.query;

  return (
    <Suspense>
      <ScreenCbtCategory />
      <ScreenCbtBest isShowBestList={!examTypeIds} />
      <ScreenCbtList />
    </Suspense>
  );
};

export default ScreenCbtHome;
